import BasicValidation from 'components/components/common/BasicValidation';
import TransHelper from 'components/common/translations/TransHelper';

export default class CustomerBasicDataValidation extends BasicValidation {
  constructor(isBooking = false,locale = "en") {
    super();
    this.isBooking = isBooking;
    this.locale = locale;
  }

  trans = (key) => {
    return TransHelper.translate( this.locale, 'content.errors.auth.customerBasicValidation.' + key);
  }

  validationName(value) {
    if (this.checkLengthIsTooShort(value, 3)) {
      return this.trans('nameToShort');
    }

    if (this.checkLengthIsTooLong(value)) {
      return this.trans('nameToLong');
    }
    return null;
  }

  isValidName(value) {
    return this.validationName(value) === null;
  }

  validationEmail(value) {
    if (!this.checkIsEmail(value)) {
      return this.trans('emailInvalid');
    }
    return null;
  }

  isValidEmail(value) {
    return this.validationEmail(value) === null;
  }

  validationPassword(value) {
    if (this.checkLengthIsTooShort(value, 5)) {
      return this.trans('passwordToShort5chars');
    }

    if (this.checkLengthIsTooLong(value)) {
      return this.trans('passwordToLong');
    }
    return null;
  }

  isValidPassword(value) {
    return this.validationPassword(value) === null;
  }

  shouldValidatePassword(data) {
    if(this.isBooking){
      return this.isBooking && data.createAccountWithBooking;
    } else {
      return true;
    }
  }

  getFieldsErrors(data) {
    var errors = {
      name: this.validationName(data.name),
      email: this.validationEmail(data.email),
    };

    if (this.shouldValidatePassword(data)) {
      errors['password'] = this.validationPassword(data.password);
    }
    return errors;
  }

  isValidForm(data) {
    var isValid = this.isValidName(data.name) &&
      this.isValidEmail(data.email);
    if (this.shouldValidatePassword(data)) {
      isValid = isValid && this.isValidPassword(data.password);
    }

    return isValid;

  }
}